jQuery(document).ready(function ($) {

    const $tabs = $('.tab-btns__toggle-tab');
    if ($tabs.length) {
        function activateTabByHash(hash) {
            if (!hash) {
                hash = 'all';
            }
            const $tabsContainer = $('.tab__container .tab__item');

            const $targetTab = $tabs.filter(function () {
                return $(this).data('publication_type') === hash;
            });

            if (!$targetTab.length) return;

            $tabs.removeClass('js-tab-active active');
            $tabsContainer.removeClass('js-tab-active active');

            $targetTab.addClass('js-tab-active active');

            const targetIndex = $targetTab.index();
            $tabsContainer.eq(targetIndex).addClass('js-tab-active active');
        }


        $tabs.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let hash = $(this).data('publication_type');

            if (!hash || hash === 'undefined') {
                history.pushState('', document.title, window.location.pathname);
                activateTabByHash('all');
                return;
            }

            if (hash === 'all') {
                history.pushState('', document.title, window.location.pathname);
                activateTabByHash('all');
            } else {
                window.location.hash = hash;
                activateTabByHash(hash);
            }
        });

        let initialHash = window.location.hash.replace('#', '');

        if (!initialHash || initialHash === 'undefined') {
            initialHash = 'all';
            history.replaceState('', document.title, window.location.pathname);
        }

        activateTabByHash(initialHash);

        $('body').on('click', '.selection__result', function (e) {
            e.stopPropagation();
            $(this)
                .closest('.calculator_wrap')
                .find('.title__change')
                .text($(this).find('.selection__text').text());
        });
    }

});
